import { useTranslation } from 'react-i18next';
import Loader from 'components/Loader/Loader';
import Title from 'components/Title/Title';

import LaunchpadLanes from './components/LaunchpadLanes/LaunchpadLanes';
import ValueChainHeader from './components/ValueChainHeader/ValueChainHeader';
import LaunchpadHubLoading from './LaunchpadHubLoading';

import type ILaunchpadHubView from './interfaces/ILaunchpadHubView';

import styles from './sass/LaunchpadHubView.module.scss';

function LaunchpadHubView({
  isLoading,
  hasActiveVcm,
  valueChainMaps,
  selectedMapId,
  selectedMap,
  onSelectMapId,
  onDiscoverClick,
}: ILaunchpadHubView) {
  const { t } = useTranslation();

  return (
    <div className={styles.root}>
      <Loader isPageLoading={isLoading} isFullLoader={false} />
      <div className={styles.hubMain}>
        <div className={styles.hubContent}>
          <ValueChainHeader
            selectedMap={selectedMap}
            maps={valueChainMaps}
            onSelectMapId={onSelectMapId}
          />
          <div className={styles.header}>
            <Title text={t('launchpad.pageTitle')} />
          </div>
          {isLoading ? (
            <LaunchpadHubLoading />
          ) : (
            <LaunchpadLanes
              hasActiveVcm={hasActiveVcm}
              selectedMapId={selectedMapId}
              onDiscoverClick={onDiscoverClick}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default LaunchpadHubView;
